import { doc, getDoc, serverTimestamp, setDoc } from 'firebase/firestore';
import { db } from '../../../../firebase';
import { displayCommunityName } from '../../../../shared/utils/user';

type UserProfile = Record<string, any> & { id: string };

export const communityProfileSnapshot = (profile: UserProfile) => ({
  username: profile.username || '',
  displayName: displayCommunityName(
    [profile.firstName, profile.lastName].filter(Boolean).join(' '),
  ),
  avatar: profile.avatar || '',
  color: profile.color || '',
  visited: profile.visited || [],
  updatedAt: serverTimestamp(),
});

export const syncCommunityProfile = async (profile: UserProfile) => {
  if (!db) return;
  await setDoc(
    doc(db, 'communityProfiles', profile.id),
    communityProfileSnapshot(profile),
  );
};

export const getCommunityProfile = async (userId: string) => {
  if (!db) return null;
  const snapshot = await getDoc(doc(db, 'communityProfiles', userId));
  return snapshot.exists() ? { id: snapshot.id, ...snapshot.data() } : null;
};
